import { jsx as _jsx } from "react/jsx-runtime";
import { EyeIcon } from '../components/svgIcons/eye.icon';
import { SiteIcon } from '../components/svgIcons/site.icon';
import { UserIcon } from '../components/svgIcons/user.icon';
export const getActivityIcon = (type) => {
    switch (type) {
        case 'obsro':
            return _jsx(EyeIcon, { height: 16, width: 16, className: 'text-blue-500' });
        case 'clinro':
            return _jsx(SiteIcon, { height: 16, width: 16, className: 'text-green-500' });
        case 'epro':
            return _jsx(UserIcon, { height: 16, width: 16, className: 'text-purple-500' });
        default:
            return null;
    }
};
